import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SuperloginService, LoginRequest } from './superlogin.service';
import { ToastrService } from 'ngx-toastr'; 


@Component({
  selector: 'app-superlogin',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './superlogin.component.html',
  styleUrls: ['./superlogin.component.css']
})
export class SuperloginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  showPassword = false;
  loginAttempted = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private superloginService: SuperloginService,
    private router: Router,
    private toaster: ToastrService 
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
    if (this.superloginService.isAuthenticated()) {
      this.router.navigate(['/dashboard']); 
    }
  }

  onSubmit(): void {
    this.loginAttempted = true;
    this.errorMessage = '';

    if (this.loginForm.valid) {
      this.isLoading = true;
      
      const credentials: LoginRequest = {
        username: this.loginForm.get('username')?.value,
        password: this.loginForm.get('password')?.value
      };

      this.superloginService.login(credentials).subscribe({
        next: (response) => {
          this.isLoading = false;
          console.log('Login successful:', response);
          
          this.toaster.success('Logged in successfully!', 'Welcome!');
          
              this.router.navigateByUrl('/dashboard');
        },
        error: (err) => {
          this.isLoading = false;
          
          const apiErrorMessage = err.error?.error || 'Login failed. Invalid username or password.';

          this.errorMessage = apiErrorMessage; 
          
          this.toaster.error(apiErrorMessage, 'Login Failed', {
            positionClass: 'toast-top-center',
            closeButton: true,
            timeOut: 5000 
          });

          console.error('Login failed:', err);
          
        }
      });
    } else {
      this.markFormGroupTouched();
      this.toaster.warning('Please correct the highlighted fields.', 'Validation Error');
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  private markFormGroupTouched(): void {
    Object.keys(this.loginForm.controls).forEach(key => {
      const control = this.loginForm.get(key);
      control?.markAsTouched();
    });
  }

  get username() {
    return this.loginForm.get('username');
  }

  get password() {
    return this.loginForm.get('password');
  }

  get isUsernameInvalid(): boolean {
    const username = this.username;
    return !!(username && username.invalid && (username.dirty || username.touched || this.loginAttempted));
  }

  get isPasswordInvalid(): boolean {
    const password = this.password;
    return !!(password && password.invalid && (password.dirty || password.touched || this.loginAttempted));
  }
}